/**
 * ChatIcon/index.js
 * desc: chat icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ChatIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="chat icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.chat.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15 1v9c0 .55-.45 1-1 1H4l-4 4V1c0-.55.45-1 1-1h13c.55 0 1 .45 1 1zm2 3h2c.55 0 1 .45 1 1v15l-4-4H5c-.55 0-1-.45-1-1v-2h13V4z" /></svg>
    </IconButton>
);


export default ChatIcon;
